/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Mock_DescInputs */

const en_st_mock_desc = /** @type {(inputs: St_Mock_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your logo and colour, their language, no Bystep account needed beyond signing in.`)
};

const id_st_mock_desc = /** @type {(inputs: St_Mock_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo dan warna kamu, bahasa mereka, tanpa perlu paham Bystep.`)
};

/**
* | output |
* | --- |
* | "Your logo and colour, their language, no Bystep account needed beyond signing in." |
*
* @param {St_Mock_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_mock_desc = /** @type {((inputs?: St_Mock_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Mock_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_mock_desc(inputs)
	return en_st_mock_desc(inputs)
});